import { useEffect } from 'react';
import { useMobileOptimizations } from './useMobileOptimizations';

/**
 * Hook para bloquear scroll do body quando sidebar ou modal está aberto no mobile
 * @param isOpen - Estado que indica se sidebar/modal está aberto
 */
export const useBodyLock = (isOpen: boolean) => {
  const { isMobile } = useMobileOptimizations();

  useEffect(() => {
    if (isOpen) {
      // Salvar posição atual do scroll (principalmente para mobile)
      const scrollY = window.scrollY;
      
      if (isMobile) {
        // Aplicar estilos para bloquear scroll no mobile (hack fixed)
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
      } else {
        // Aplicar apenas overflow hidden no desktop
        document.body.style.overflow = 'hidden';
        // Adicionar padding-right para evitar shift do scrollbar
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        if (scrollbarWidth > 0) {
          document.body.style.paddingRight = `${scrollbarWidth}px`;
        }
      }
      
      // Cleanup: restaurar scroll quando fechar
      return () => {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        if (isMobile) {
          window.scrollTo(0, scrollY);
        }
      };
    }
  }, [isMobile, isOpen]);
};
